import { useMemo } from 'react';
import { MaskitoOptions } from '@maskito/core';

import { MaskConfig } from '../../types';
import { createBrandedMaskConfig } from '../../utils';

import { PhoneMaskProps } from './types';
import { getPhoneMask } from './utils';

/**
 * Хук масок телефона
 */
export const usePhoneMask = (props: PhoneMaskProps = {}): MaskConfig => {
    const { allowAnyRegion } = props;

    const maskitoOptions: MaskitoOptions = useMemo(() => {
        return getPhoneMask({
            allowAnyRegion,
        });
    }, [allowAnyRegion]);

    const result = useMemo(
        () =>
            createBrandedMaskConfig({
                maskitoOptions,
                transformToUnmasked: value => {
                    // Удаляем все символы, которые не являются цифрой, плюсом или звёздочкой
                    const symbolsToRemove = /[^\d\+\*]/g;

                    return value.replace(symbolsToRemove, '');
                },
            }),
        [maskitoOptions],
    );

    return result;
};
